import React from "react"
import "./section.css"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const Section = (props) => {
  let urlSection = ""
  let titleSection = ""
  let textSection = ""

  if (props.data == null) {
    urlSection = props.url_bg
    titleSection = props.title
    textSection = props.text
  } else {
    urlSection = props.data.bgimage?.file?.url || ""
    titleSection = props.data.title?.title || ""
    textSection = props.data.contenido?.raw ? JSON.parse(props.data.contenido.raw) : ""
  }

  return (
    <div className="Section">
      <div className="SectionInner">
        {urlSection && (
          <div className="SectionImageWrapper">
            <img
              className="SectionImage"
              src={urlSection}
              alt={titleSection}
            />
          </div>
        )}
        <div className="SectionContent">
          <h3 className="SectionTitle">{titleSection}</h3>
          <div className="SectionText">
            {typeof textSection === "string"
              ? textSection
              : documentToReactComponents(textSection)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section
